var indentation_default = {
  "indentZero": "_41BxQ",
  "indentOne": "wlxXY",
  "indentTwo": "uXCyf",
  "indentThree": "_746dJ",
  "indentFour": "QC6Qc",
  "indentFive": "sLvSN",
  "indentSix": "WSqt-"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
